import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgenteClientService } from './agente-client.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [AgenteClientService],
})
export class AgenteClientModule { }
